<section id="kil">
  <div class="flex" style="height: fit-content; justify-content: end;padding: 0 10px;" class="flex">
    <button mat-dialog-close="true" mat-icon-button>
        <mat-icon style="font-size: inherit;">close</mat-icon>
      </button>
      </div>
    <section>
        <div class="flex" style="height: fit-content;justify-content: end;">
            <div *ngIf="selected">
               <div class="flex">

               <!-- <div id="lkj" *ngIf="closey">
    
                    <p>After successful completion of payment kindly click the finish button.</p>
                    <button (click)="closey =!closey" style="color: var(--secondary-color);" mat-icon-button>
                        <mat-icon>cancel</mat-icon>
                    </button>
                </div> -->
               </div> 

            </div>
            
             <!-- <button mat-icon-button (click)="close()" color="warn">
                <mat-icon class="mat-18">close</mat-icon>
            </button> -->
        </div>

        <div *ngIf="!selected"> 
            <br><br>

            <h3 class="header__txt">Choose Payment Method</h3>
            <div class="flex button__wrapper">
                <div *ngIf="user['role'] != 'staff'">
                    <button mat-button (click)="payWithWallet()">
                        <h3><mat-icon>wallet</mat-icon></h3>
                        <span>Pay With Wallet</span>
                        <p>Wallet Balance</p>
                        <h3>{{wallet['balance'] | currency:"NGN "}}</h3>
                    </button>
                </div>

                <div *ngIf="unitsView">
                    <button mat-button (click)="payWithUnits()">
                        <h3><img src="../../assets/unit-icon-2.svg" alt=""></h3>
                        <span>Pay With Units</span>
                        <p>Units Balance</p>
                        <h3>{{user['units'] | currency: '₦ ' }}</h3>
                    </button>
                </div>
                
                <div *ngIf="user['role'] != 'staff'">
                    <button mat-button (click)="instaPay()">
                        <h3><mat-icon>payment</mat-icon></h3>
                        <span>Instant Payment</span>
                    </button>
                </div>
            </div>
        </div>

        <div *ngIf="selected">
            <br><br>
            <h3 class="header__txt">Choose Payment Channel</h3>
            <div class="flex button__wrapper">
                <!-- <div>
                    <button (click)="payWithFlutterwave()" mat-button>
                        <img height="90" src="https://customerdocument.blob.core.windows.net/customerdocuments/flutterwave.png" alt="">
                    </button>
                </div> -->
                
                <div>
                    <button (click)="payWithPaystack()" mat-button>
                        <img height="40" src="https://customerdocument.blob.core.windows.net/customerdocuments/paystack-logo-removebg-preview.png" alt="">
                    </button>
                </div>
            </div>
            <!-- <p>If you were not redirected, kindly click the below button to complete your transaction</p>
            <a mat-raised-button color="accent" [href]="cleanURL(datas['payment_url'].authorization_url)"></a> -->
        </div>
    </section>
</section>
